<template>
  <div class="slide-toggle-container">
    <div
      :class="{
        'slide-toggle': true,
        'slide-toggle-active': !!this.value,
      }"
      @click="onToggle"
    >
      <div class="slide-toggle-circle"></div>
    </div>
    <div
      :class="{
        'slide-toggle-label': true,
        'slide-toggle-label-active': !!this.value,
      }"
      v-if="$slots.default"
    >
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: { value: [String, Number, Boolean] },

  methods: {
    onToggle() {
      this.$emit("input", !this.value);
    },
  },
};
</script>

<style scoped>
.slide-toggle {
  background: #908f8d;
  width: 6.666vh;
  height: 2.777vh;
  border-radius: 5vh;
  transition: 0.2s;
  cursor: pointer;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.slide-toggle-circle {
  width: 2.111vh;
  height: 2.111vh;
  border-radius: 50%;
  background: #ffffff;
  transition: 0.2s;
  z-index: 1;
  position: absolute;
  left: 0.3vh;
}

.slide-toggle-active {
  background: #129b81;
  transition: 0.2s;
}

.slide-toggle-container {
  display: flex;
  align-content: center;
  align-items: center;
}

.slide-toggle-label {
  margin-left: 1.65vh;
  color: #a4a3a1;
  font-size: 2.3vh;
}

.slide-toggle-label-active {
  color: #ededed;
}

.slide-toggle-active .slide-toggle-circle {
  left: 4.2vh;
  transition: 0.2s;
}
</style>
